export const APP_START_LOADER_KEY = "__wevideoAppStartLoader";
export const APP_START_LOADER_SOURCE = "loader";
export const APP_START_LOADER_PROBE = "loader";
export const APP_START_LOADER_CONFIG_PLACEHOLDER = "__APP_START_LOADER_CONFIG__";

type AppStartLoaderErrorKind = "error" | "rejection" | "bundle_load" | "start_timeout" | "probe";

export type AppStartLoaderError = {
	kind: AppStartLoaderErrorKind;
	type: string;
	message: string;
	stack?: string;
	src?: string;
	error?: unknown;
	probe?: boolean;
};

// `window[APP_START_LOADER_KEY]`, written by the inline script and read by `initErrorTracking`.
export type AppStartLoaderState = {
	errors: AppStartLoaderError[];
	sent: boolean;
	started: boolean;
	stop: () => void;
};

export type AppStartLoaderConfig = {
	stateKey: string;
	appName: string;
	codeSource?: string;
	// Entry file name without extension to app name, for a page whose entry the server chooses.
	appNames?: Record<string, string>;
	release: string;
	endpoint: string;
	appVersionHeader: string;
	startTimeoutMs: number;
	maxBufferedErrors: number;
	maxMessageLength: number;
	maxDetailLength: number;
	localHosts: string[];
	localEnvironment: string;
	hostEnvironments: [string, string][];
	defaultEnvironment: string;
	productionEnvironments: string[];
	probeParam: string;
	probeValue: string;
	probeType: string;
	failureType: string;
	impact: string;
	source: string;
	tags: Record<string, string>;
	tagNames: {
		appName: string;
		codeSource: string;
		operation: string;
		pageUrl: string;
		probe: string;
		failedChunk: string;
		failedChunkStatus: string;
		failedChunkDuration: string;
		failedChunkSize: string;
		connectionType: string;
		autoReload: string;
	};
};

export const adoptAppStartLoader = (): AppStartLoaderState | null => {
	if (typeof window === "undefined") return null;
	const state = (window as unknown as Record<string, unknown>)[APP_START_LOADER_KEY] as
		| AppStartLoaderState
		| undefined;
	if (!state || typeof state.stop !== "function") return null;
	try {
		state.stop();
	} catch {
		// Must not throw.
	}
	return state;
};
